import React from 'react';
import styled from 'styled-components';
import {
  colors,
  fonts,
  breakpoints,
  radii,
  headingStyle,
  sectionPaddingStyle,
  containerStyle,
  serviceCategoryColors,
  getServiceCategory,
  icones,
} from '../annuaire/designSystem';

const Section = styled.section`
  margin: 0;
  ${sectionPaddingStyle}
  background-color: ${colors.bleuFonce};
`;

const Container = styled.div`
  ${containerStyle}
`;

const Heading = styled.h2`
  ${headingStyle}
  color: ${colors.white};
  font-size: 1.5rem;
  margin-bottom: 32px;

  @media (min-width: ${breakpoints.mobile}) {
    font-size: 2.125rem;
  }
`;

const EmphasisLime = styled.span`
  color: ${colors.vert};
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (min-width: ${breakpoints.mobile}) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 24px;
  }
`;

const ServiceCard = styled.div`
  border-radius: ${radii.card};
  padding: 24px;
  text-align: center;
  transition: all 0.2s ease;
  background-color: ${(p) => p.$bg || colors.bleuPastel};

  &:hover {
    transform: translateY(-4px);
    background-color: ${(p) => p.$hoverBg || p.$bg || colors.bleuPastel};
  }
`;

const ServiceIcon = styled.img`
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin: 0 auto 16px;
`;

const ServiceName = styled.h4`
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.3;
  color: ${(p) => p.$color || colors.textDark};
  margin: 0;
`;

// Hover colors slightly darker than the category bg
const HOVER_COLORS = {
  vente: '#c8dffa',
  atelier: '#ddd0f5',
  extra: '#ffd0ba',
};

// Service icons mapping (RoulezJeunesse branded)
const SERVICE_ICON_SRCS = {
  vente: icones.shop,
  atelier: icones.outils,
  extra: icones.shop,
};

export default function ShopServices({ shop }) {
  const details = shop.details || {};
  const services = details.services || [];

  if (services.length === 0) return null;

  return (
    <Section>
      <Container>
        <Heading>
          Services <EmphasisLime>propos&eacute;s</EmphasisLime>
        </Heading>
        <ServicesGrid>
          {services.map((svc, i) => {
            const cat = getServiceCategory(svc);
            const catColors =
              serviceCategoryColors[cat] || serviceCategoryColors.extra;
            return (
              <ServiceCard
                key={i}
                $bg={catColors.bg}
                $hoverBg={HOVER_COLORS[cat] || catColors.bg}>
                <ServiceIcon
                  src={SERVICE_ICON_SRCS[cat] || SERVICE_ICON_SRCS.extra}
                  alt={svc}
                />
                <ServiceName $color={catColors.text}>{svc}</ServiceName>
              </ServiceCard>
            );
          })}
        </ServicesGrid>
      </Container>
    </Section>
  );
}
